
export const backgroundBlue = '#0294fc'

export const standardTheme = {}